import { create } from 'zustand';

const useCrmStore = create((set) => ({
  range: {
    startDate: new Date(new Date().setHours(0, 0, 0, 0)),
    endDate: new Date(new Date().setHours(23, 59)),
    key: 'selection',
  },
  setRange: (range) => set(() => ({ range })),
  group: null,
  setGroup: (group) => {
    set(() => ({ group }));
  },
  team: null,
  setTeam: (team) => set(() => ({ team })),
  filter: null,
  setFilter: (filter) => {
    set(() => ({ filter }));
  },
  sort: null,
  setSort: (sort) => set(() => ({ sort })),
  interface: null,
  setInterface: (iFace) => set(() => ({ interface: iFace })),
  filterCategorie: null,
  setFilterCategorie: (filterCat) =>
    set(() => ({ filterCategorie: filterCat })),
  errors: [],
  setErrors: (errors) => set(() => ({ errors })),
  addError: (error) => set((state) => ({ errors: [...state.errors, error] })),
}));

export default useCrmStore;
